import React from 'react';
import PropTypes from 'prop-types';
import styles from './StepCard.module.scss';

const StepCard = ({ stepNumber, title, description }) => (
  <div className={styles.card}>
    <h3 className={styles.step}>STEP {stepNumber}</h3>
    <h4 className={styles.title}>{title}</h4>
  </div>
);

StepCard.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default StepCard;
